var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"class-name":"skeleton d-flex flex-column justify-center"}},[_c('v-card',{attrs:{"rounded":"","elevation":"4"}},[_c('v-skeleton-loader',{staticClass:"image",attrs:{"type":"image","height":"216px"}})],1),_c('v-skeleton-loader',{staticClass:"title",attrs:{"type":"heading"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }